export const formatNum = (stat: string): string => {
  return isNaN(Number(stat)) ? stat : Number(stat).toLocaleString();
};
